import {
  customizationRoleLabels as roleLabels,
  customizationRoleOptions as roleOptions,
  customizationSourceLabels as sourceLabels,
  customizationSourceOptions as sourceOptions,
} from "../config";

/** 追溯角色选项，供工作台 UI 统一展示。 */
export const customizationRoleOptions = roleOptions;

/** 追溯来源选项，供工作台 UI 统一展示。 */
export const customizationSourceOptions = sourceOptions;

/** 追溯角色文案映射，供工作台 UI 统一展示。 */
export const customizationRoleLabels = roleLabels;

/** 追溯来源文案映射，供工作台 UI 统一展示。 */
export const customizationSourceLabels = sourceLabels;
